import request from '@/utils/request'

export const getEditorUsage = (params) => request({
  url: '/admin/editor-usage',
  method: 'GET',
  params
})

/**
 * 获取简历数据
 * @param {Object} data
 * @param {number} data.page - 页码
 * @param {number} data.limit - 每页条数
 * @param {string} data.keyword - 搜索关键词
 * @returns {Promise<Object>}
 */
export const getResumeList = (page, limit, keyword) => {
  return request({
    url: '/admin/resumes',
    method: 'GET',
    params: { page, limit, keyword }
  })
}

/**
 * 根据简历 id，获取简历详情
 */
export const getResumeDetail = (id) => {
  return request({
    url: `/admin/resume/${id}`,
    method: 'GET'
  })
}
